<div class="w-full h-5 overflow-hidden flex text-center text-white">
  @if (noResultCount() > 0) {
    <div class="h-full bg-black" [style.width]="noResultPercentage()" matTooltip="Sites en erreur">{{ noResultCount() }}<small> / {{ sites().length }}</small></div>
  }

  @if (notFoundCount() > 0) {
    <div class="h-full bg-error" [style.width]="notFoundPercentage()" matTooltip="Sites introuvables">{{ notFoundCount() }}<small> / {{ sites().length }}</small></div>
  }

  @if (unsureCount() > 0) {
    <div class="h-full bg-warning" [style.width]="unsurePercentage()" matTooltip="Sites incertains">{{ unsureCount() }}<small> / {{ sites().length }}</small></div>
  }

  @if (confirmedCount() > 0) {
    <div class="h-full bg-success" [style.width]="confirmedPercentage()" matTooltip="Sites fiabilisés">{{ confirmedCount() }}<small> / {{ sites().length }}</small></div>
  }

  @if (inProgressCount() > 0) {
    <div class="h-full bg-grey" [style.width]="inProgressPercentage()" matTooltip="Sites en cours de fiabilisation">{{ inProgressCount() }}<small> / {{ sites().length }}</small></div>
  }
</div>